
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#FAE6E9","cx":"50","cy":"50","r":"50"}}),_c('g',{attrs:{"stroke":"#F52F4C","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M53.392 63.965a4.662 4.662 0 00-6.784 0L50 67.5l3.392-3.535z","fill":"#F52F4C"}}),_c('path',{attrs:{"d":"M63.571 53.359C59.971 49.608 55.091 47.5 50 47.5c-5.09 0-9.972 2.107-13.571 5.858M73.75 42.752C67.451 36.188 58.908 32.5 50 32.5s-17.451 3.688-23.75 10.252"}})])])])
          )
        }
      }
    